import axios from "../utils/axios.wrapper";

const normalizeListResponse = (data) => ({
  items: Array.isArray(data?.items)
    ? data.items
    : Array.isArray(data?.Items)
    ? data.Items
    : Array.isArray(data)
    ? data
    : [],
  totalCount:
    data?.totalCount ??
    data?.TotalCount ??
    (Array.isArray(data?.items) ? data.items.length : 0) ??
    (Array.isArray(data?.Items) ? data.Items.length : 0),
});

export const getPosRechargeList = async () => {
  const response = await axios.get("/PosRecharge");
  return normalizeListResponse(response.data);
};

export const getPosRechargeById = async (id) => {
  const response = await axios.get(`/PosRecharge/${id}`);
  return response.data;
};

export const getPosRechargesByPos = async (posId) => {
  const response = await axios.get(`/PosRecharge/by-pos/${posId}`);
  return normalizeListResponse(response.data);
};

export const getPosRechargesByDateRange = async (filter) => {
  const response = await axios.post("/PosRecharge/by-date-range", filter);
  return normalizeListResponse(response.data);
};

export const createPosRecharge = async (recharge) => {
  const response = await axios.post("/PosRecharge/create", recharge);
  return response.data;
};

export const updatePosRecharge = async (id, recharge) => {
  const response = await axios.put(`/PosRecharge/${id}`, recharge);
  return response.data;
};

export const deletePosRecharge = async (id) => {
  await axios.delete(`/PosRecharge/${id}`);
  return id;
};

export const hardDeletePosRecharge = async (id) => {
  await axios.delete(`/PosRecharge/hard/${id}`);
  return id;
};

export const posRechargeService = {
  getPosRechargeList,
  getPosRechargeById,
  getPosRechargesByPos,
  getPosRechargesByDateRange,
  createPosRecharge,
  updatePosRecharge,
  deletePosRecharge,
  hardDeletePosRecharge,
};